<template>
    <a-layout-content style="height: 100%;">
      <a-spin :spinning="loading.page">
        <a-card style="flex: 1; display: flex; flex-direction: column;">
          <span class="m-text-title" slot="title">{{page == 'create' ? 'Create' : 'Revise'}} Klaim Kesehatan</span>
          <a-row :gutter="[8,8]" style="align-items: stretch;">
            <a-col :xs="24" :lg="8">
              <a-card style="height: 100%;">
                <a-form class="m-form" :form="form">

                  <a-form-item v-show="page !== 'revise'" label="Nama Karyawan:">
                    <a-select
                      show-search
                      :disabled="listData.length > 0 || page == 'revise'"
                      @change="onSelectName"
                      :filterOption="false"
                      @search="onSearch"
                      v-decorator="[
                        'employee',
                        { rules: page !== 'revise' ? [{ required: true, message: 'Member is required!' }] : [{ required: false }] }
                      ]"
                    >
                    <a-select-option v-for="c in filteredComboName" :key="c.tlc" :value="c.tlc">{{c.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  
                  <a-form-item label="Anggota Keluarga:">
                    <a-select
                    :disabled="listData.length > 0 || page == 'revise'"
                    @change="onChangeSelect"
                    v-decorator="[
                      'member_select',
                      { rules: [{ required: true, message: 'Member is required!' }] }
                    ]"
                    >
                    <a-select-option v-for="c in combo" :key="c.id_member" :value="c.id_member">{{c.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- <a-divider>Detail informasi</a-divider> -->
  
                  <!-- <a-form-item label="Upload Dokumen" :required="false">
                    <a-upload
                      name="file"
                      :file-list="fileList"
                      :before-upload="() => false"
                      @change="handleChangeUpload"
                      :getValueFromEvent="normFile"
                      v-decorator="['dokumen', {
                          rules: [{
                              required: false,
                              message: 'Dokumen is required!'
                          }]
                      }]"
                    >
                      <a-button v-if="fileList.length == 0"> <a-icon type="upload" /> Click to Upload </a-button>
                    </a-upload>
                  </a-form-item> -->
  
                  <a-form-item label="Tanggal:">
                      <a-date-picker
                      class="w-full"
                      :format="getDefaultDateFormat"
                      v-decorator="['invoice_date',
                          {
                              rules: [
                                { required: true, message: 'Tanggal is required!' },
                                { validator: checkDate }
                              ]
                          }
                      ]"
                      />
                  </a-form-item>
  
                  <a-form-item label="Deskripsi">
                      <a-input
                      autocomplete="off"
                      v-decorator="[
                          'description',
                          { rules: [{ required: true,message: 'Deskripsi is required!' }] }
                      ]"
                      />
                  </a-form-item>
                  <a-form-item label="Nilai Klaim">
                    <a-input-number id="inputNumber" :min="1"
                    :formatter="rupiahFormatter"
                    :parser="rupiahParser"
                    class="w-full" 
                      v-decorator="[
                          'nilai_klaim',
                          { rules: [{ required: true,message: 'Nilai klaim is required!' }] }
                      ]"
                    />
                  </a-form-item>
                  <!-- <a-form-item label="Keterangan">
                      <a-textarea
                          :auto-size="{ minRows: 3, maxRows: 5 }"
                          v-decorator="['note', {
                              rules: [{
                                  required: false,
                                  message: 'Keterangan is required!'
                              }],
                          }]"
                      />
                  </a-form-item> -->
                </a-form>
  
                <div v-if="page == 'create'">
                  <div v-if="state_data.mode == 'create'" class="w-full m-top-10">
                      <a-button type="primary" icon="plus" @click="addDetail" class="w-full">Tambah</a-button>
                  </div>
                  <div v-else class="d-flex justify-between items-center m-top-10">
                    <a-button type="secondary" @click="cancelEdit">Cancel</a-button>
                    <a-button type="primary" icon="save" @click="saveEdit">Simpan</a-button>
                  </div>
                </div>
                <div v-else-if="page == 'revise'">
                  <div v-if="state_data.mode == 'create'" class="w-full m-top-10">
                      <a-button :loading="loading.add" type="primary" icon="plus" @click="addDetailRevise" class="w-full">Tambah</a-button>
                  </div>
                  <div v-else class="d-flex justify-between items-center m-top-10">
                    <a-button type="secondary" @click="cancelEdit">Cancel</a-button>
                    <a-button :loading="loading.update" type="primary" icon="save" @click="saveEditRevise">Simpan</a-button>
                  </div>
                </div>
                
              </a-card>
            </a-col>
            <a-col :xs="24" :lg="16">
              <a-card style="height: 100%;">
                <!-- Header Info -->
                <div style="display: flex; flex-direction: column;">
                  <span>Nama Anggota : {{ headerNm }}</span>
                  <span>Keanggotaan : {{ headerSub }}</span>
                </div>
  
                <!-- Table -->
                <a-table
                  :columns="columns"
                  :data-source="listData"
                  bordered
                  style="margin-top: 10px; flex: 1; height: 100%;"
                  :pagination="pagination"
                  :scroll="widthScreen < 400 ? { x: 1200, y:500} : {}"
                  :loading="loading.table"
                  size="small"
                  key="tblMember"
                  :rowKey="(record, index) => index"
                >
                  <!-- slot templates -->
                  <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
                  <template slot="invoice_date" slot-scope="value, item, index">
                    <div style="display: flex; flex-direction: column;">
                      <span>{{ moment(item.invoice_date).format("DD-MM-YYYY") }}</span>
                    </div>
                  </template>
                  <template slot="description" slot-scope="value, item, index">{{ item.description }}</template>
                  <template slot="nilai_klaim" slot-scope="value, item, index">{{ formatRupiah(item.nilai_klaim) }}</template>
                  <!-- <template slot="dokumen" slot-scope="value, item, index">
                    <a-button v-if="item.dokumen" icon="eye" @click="viewDocument(item.dokumen)">View</a-button>
                    <span v-else>-</span>
                  </template> -->
                  <template slot="action" slot-scope="value, item, index">
                    <div style="display: flex; flex-direction: row; gap: 10px; justify-content: center;"> 
                      
                      <a-popconfirm v-if="page == 'create'" placement="bottomRight" ok-text="Yes" cancel-text="No" @confirm="deleteMember(item)">
                        <template slot="title">
                          <p>Are you sure want to delete ?</p>
                        </template>
                        <a-button shape="circle" icon="delete" />
                      </a-popconfirm>
                      <a-popconfirm v-else-if="page == 'revise'" placement="bottomRight" ok-text="Yes" cancel-text="No" @confirm="deleteKlaim(item)">
                        <template slot="title">
                          <p>Are you sure want to delete ?</p>
                        </template>
                        <a-button shape="circle" icon="delete" />
                      </a-popconfirm>
  
                      <a-button shape="circle" icon="edit" @click="editMember(item)" />
                    </div>
                  </template>
                </a-table>
  
                <!-- Footer Stay Bottom -->
                <div style="margin-top: auto;">
                  <div style="font-weight: 600; text-align: right; margin-top: 10px">
                    Total Klaim : {{ formatRupiah(grandTotal) }}
                  </div>
                  <a-divider></a-divider>
                  <div style="display: flex; justify-content: space-between;">
                    <a-button @click="back">Cancel</a-button>
                    <a-button v-if="page == 'create'" type="primary" icon="save" :loading="loading.submit" @click="handleSubmit">Submit</a-button>
                    <a-button v-else-if="page == 'revise'" type="primary" icon="save" :loading="loading.submit" @click="submitRevise">Submit</a-button>
                  </div>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </a-card>
      </a-spin>
    </a-layout-content>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  
  const columns = [
    {
      title: 'No',
      width: 40,
      className: 'center',
      scopedSlots: { customRender: 'no' },
    },
    {
      title: 'Tanggal',
      dataIndex: 'invoice_date',
      scopedSlots: { customRender: 'invoice_date' },
    },
    {
      title: 'Deskripsi',
      dataIndex: 'description',
      scopedSlots: { customRender: 'description' },
    },
    {
      title: 'Nilai Klaim',
      dataIndex: 'nilai_klaim',
      className: 'center',
      scopedSlots: { customRender: 'nilai_klaim' },
    },
    // {
    //   title: 'Dokumen',
    //   className: 'center',
    //   dataIndex: 'dokumen',
    //   scopedSlots: { customRender: 'dokumen' },
    // },
    {
      title: 'Action',
      className: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];
  export default{
    mixins: [CurrencyFormat],
    props: ["id"],
    data(){
      return {
        page: 'create',
        moment,
        columns,
        combo: [],
        comboName: [],
        filteredComboName: [],
        pagination: {
          pageSize: 5
        },
        fileList: [],
        header: {},
        headerNm: "",
        headerSub: "",
        listData: [],
        widthScreen: 0,
        heighScreen: 0,
        loading: {
          table: false,
          submit: false,
          page: false,
          add: false,
          update: false
        },
        grandTotal: 0,
        state_data: {
          id: '',
          editData: {},
          mode: 'create'
        },
        tlc_employee: ''
      }
    },
    computed: {
      ...mapGetters([
          "getAuth",
          "getDefaultDateFormat",
          "getStandartFormatDate"
      ]),
    },

    created(){
      
    },
    mounted(){
      if(this.id){
        this.loading.page = true
        this.page = 'revise'
        this.fetchReviseData()
      }
      this.widthScreen = window.innerWidth
      this.heighScreen = window.innerHeight
      this.fetchCombo()
    },
    beforeCreate(){
      this.form = this.$form.createForm(this);
    },
    watch: {
      listData: {
        handler() {
          let total = 0;
          this.listData.forEach((d) => {
            total += d.nilai_klaim;
          });
          this.grandTotal = total;
          this.header.grand_total = total;
        },
        deep: true
    },
  
      $route(to, from) {
        if(to.name == 'createKlaim' && from.name == 'listKlaim'){
          this.fetchCombo()
        }
      }
    },
  
    methods: {
      beforeUpload(file) {
        console.log(file);
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 2) {
            this.displayMessage("large-file");
        } else {
            this.fileList = [file];
            return false;
        }
      },
  
      async handlePreviewUpload(file) {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
      },
      handleChangeUpload({ fileList }) {
        this.fileList = fileList;
      },
      normFile(e) {
        return e && e.fileList;
      },
  
      doc_validation(rule, value, callback) {
        if (this.fileList.length == 0) {
          callback(new Error("Upload File Cannot be Empty!"));
        } else {
          callback();
        }
      },
  
      async fetchCombo(){
        try {
          const response = await this.asyncAxiosGet("klaim_kesehatan/employee_combo", this.getAuth, {});
          this.comboName = response.data
          this.filteredComboName = response.data
        } catch (error) {
          console.log(error);
        }
      },
      onChangeSelect(value){
        const data = this.combo.find((d) => d.id_member == value)
        let now = new Date();
        let pad = (n) => n.toString().padStart(2, '0');
        let formatted = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
                  `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        
        this.header = {
          id_member : data.id_member,
          create_dt : formatted,
          details : [],
          grand_total : 0,
          member: data.member
        }
        this.headerNm = data.nama
        this.headerSub = data.member
      },

      async onSelectName(val){
        try {
          this.combo = []
          this.form.resetFields([
            'member_select'
          ])
          this.headerNm = ''
          this.headerSub = ''
          const payload = {
            tlc: val
          }
          this.tlc_create = val
          const response = await this.asyncAxiosGet("klaim_kesehatan/monitoring_combo_member", this.getAuth, payload);
          this.combo = response.data
        } catch (error) {
          console.log(error);
        }
      },
  
      addDetail(){
        this.form.validateFields( async (err, values) => {
          if(err){
            this.displayMessage("form-warning");
            return;
          }
          
          const payload = {
            temp_id: Date.now(),
            invoice_date: moment(values.invoice_date).format('YYYY-MM-DD'),
            dokumen: values.dokumen ? values.dokumen.fileList : null,
            member_select: values.member_select,
            nilai_klaim: values.nilai_klaim,
            note: values.note,
            file: values.dokumen ? values.dokumen.fileList[0].originFileObj : null,
            description: values.description
          }
  
          this.listData.push({...payload})
          this.displayMessage("success-save");
          this.form.resetFields([
            'description',
            'dokumen',
            'invoice_date',
            'nilai_klaim',
            'note'
          ])
          this.fileList = []
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        })
      },
  
      saveEdit(){
        this.form.validateFields( async (err, values) => {
          if(err){
            this.displayMessage("form-warning");
            return;
          }
          
          const item = this.listData.find((d) => d.temp_id == this.state_data.id);
          if(item){
            item.invoice_date = moment(values.invoice_date).format('YYYY-MM-DD')
            item.dokumen = values.dokumen ? values.dokumen.fileList : null
            item.member_select = values.member_select
            item.nilai_klaim = values.nilai_klaim
            item.note = values.note
            // item.file = values.dokumen ? ( values.dokumen.fileList[0].originFileObj ? values.dokumen.fileList[0].originFileObj : null  ) : null
            item.file = values && values.dokumen && values.dokumen.fileList && values.dokumen.fileList.length > 0
            ? values.dokumen.fileList[0].originFileObj : null;
  
            item.description = values.description
  
            this.state_data.mode = 'create'
            this.displayMessage("success-save");
            this.form.resetFields([
              'description',
              'dokumen',
              'invoice_date',
              'nilai_klaim',
              'note'
            ])
            this.fileList = []
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          }
        })
      },
  
      cancelEdit(){
        this.$nextTick(() => {
          this.form.resetFields([
            'description',
            'dokumen',
            'invoice_date',
            'nilai_klaim',
            'note'
          ])
        });
  
        this.fileList = []
        this.state_data.mode = 'create'
      },
  
      deleteMember(datas){
        const item = this.listData.filter((d) => d.temp_id !== datas.temp_id)
        this.listData = item
      },
  
      editMember(datas){
        this.state_data.mode = 'edit'
        this.state_data.editData = datas;
        this.state_data.id = datas.temp_id;
  
        if(datas.dokumen){
          this.$nextTick(() => {
            this.form.setFieldsValue({
              invoice_date: datas.invoice_date,
              dokumen: {
                file: datas.dokumen[0],
                fileList: datas.dokumen
              },
              note: datas.note,
              nilai_klaim: datas.nilai_klaim,
              description: datas.description
            })
          });
  
          this.fileList = datas.dokumen
        }else {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              invoice_date: datas.invoice_date,
              note: datas.note,
              nilai_klaim: datas.nilai_klaim,
              description: datas.description
            })
          });
        }
      },
  
      rupiahFormatter(value) {
        if (value === undefined || value === null || value === '') return ''
        // value bisa number atau string "1234567"
        const num = String(value).replace(/\D/g, '')
        if (!num) return ''
        // tambahin thousand separator '.'
        return 'Rp ' + num.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
  
      rupiahParser(displayValue) {
        if (!displayValue && displayValue !== 0) return undefined
        // buang semua non-digit
        const digits = String(displayValue).replace(/\D/g, '')
        // return number (InputNumber menyimpan ini sebagai nilai)
        return digits === '' ? undefined : Number(digits)
      },
  
      back(){
        this.form.resetFields()
        this.header = {}
        this.listData = []
        this.headerNm = ''
        this.headerSub = ''
        this.$router.push({ name: 'monitoring_klaim_list'})
      },
  
      checkDate(rule, value, callback) {
        if (!value) {
          return callback(); // Kalau kosong, biar aturan required yang handle
        }
  
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set ke jam 00:00 untuk perbandingan
  
        const minDate = new Date();
        minDate.setMonth(minDate.getMonth() - 3); // 3 bulan ke belakang
        minDate.setHours(0, 0, 0, 0);
  
        const selectedDate = new Date(value);
        selectedDate.setHours(0, 0, 0, 0);
  
        if (selectedDate.getTime() > today.getTime()) {
            return callback(new Error('Tanggal tidak boleh lebih dari hari ini!'));
        }
  
        if (selectedDate.getTime() < minDate.getTime()) {
            return callback(new Error('Tanggal tidak boleh lebih dari 3 bulan yang lalu!'));
        }
  
        return callback();
      },
  
      async handleSubmit(){
        this.loading.submit = true
        if(this.listData.length == 0){
          this.displayMessageValue("error-basic", 'Silahkan isi detail informasi terlebih dahulu');
          this.loading.submit = false
          return 
        }else {
          const payload = new FormData()
          payload.append("tlc_create", this.tlc_create)
          payload.append("header", JSON.stringify(this.header))
          payload.append("details", JSON.stringify(this.listData))
          this.listData.forEach((d) => {
            payload.append(`file[${d.temp_id}]`, d.file);
          })
  
          try {
            const response = await this.asyncAxiosPost("klaim_kesehatan/monitoring_create_klaim", "formdata", this.getAuth, payload)
            this.loading.submit = false
            this.displayMessageValue("success-basic", "Klaim kesehatan berhasil ditambahkan");
            this.back()
            window.location.reload()
          } catch (error) {
            this.displayMessageValue("error-basic", error);
            this.loading.submit = false
          }
        }
      },
  
      viewDocument(file) {
        let fileObj = file[0].originFileObj;
        if (!fileObj) {
          this.$message.error("File tidak ditemukan");
          return;
        }
  
        // Buat URL dari file object
        const fileUrl = URL.createObjectURL(fileObj);
        const fileType = fileObj.type;
        const fileName = file.name;
  
        // Jika image → buka tab baru
        if (fileType.startsWith("image/")) {
          window.open(fileUrl, "_blank");
          return;
        }
  
        // Jika PDF → buka tab baru
        if (fileType === "application/pdf") {
          window.open(fileUrl, "_blank");
          return;
        }
  
        // Selain itu → download langsung
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        // Hapus URL agar tidak memory leak
        URL.revokeObjectURL(fileUrl);
      },
  
      async fetchReviseData(){
        try {
          const payload = {
            manifest_id: this.id
          }
          const response = await this.asyncAxiosGet("klaim_kesehatan/klaim_revise", this.getAuth, payload);
          this.loading.page = false
  
          this.header = {
            id_member : response.hdr.id_member,
            create_dt : response.hdr.create_dt,
            details : [],
            grand_total : Number(response.hdr.total_klaim),
            member: response.hdr.nama_member ? response.hdr.nama_member : response.hdr.nama
          }
  
          this.headerNm = response.hdr.nama_member ? response.hdr.nama_member : response.hdr.nama
          this.headerSub = response.hdr.jenis
          this.form.setFieldsValue({
            member_select: response.hdr.id_member ? response.hdr.id_member : response.hdr.id_karyawan
          })
          this.combo = response.members
          const details = response.details
          let arrayData = []
          details.forEach(async d => {
            const payload_dtl = {
              temp_id: d.id_klaim_kesehatan_dtl,
              invoice_date: d.tgl_invoice,
              dokumen: null,
              member_select: d.id_member,
              nilai_klaim: Number(d.nilai_klaim),
              note: d.note,
              file: null,
              description: d.deskripsi
            }
  
            if(d.nama_file && d.path){
              const payload = {
                fileName: d.nama_file
              }
              const res = await this.asyncAxiosFile('klaim_kesehatan/file', this.getAuth, payload)
              const file = new File([res.data], d.nama_file, {
                type: res.data.type,
              });
              
              const fileList =[
                {
                  uid: '-1',
                  name: d.nama_file,
                  status: 'done',
                  url: this.$serviceUrl + d.path,
                  originFileObj: file,
                  type: res.data.type
                }
              ]
              payload_dtl.dokumen = fileList;
              payload_dtl.file = fileList[0].originFileObj;
            }
            arrayData.push({...payload_dtl})
          });
          this.listData = arrayData
  
        } catch (error) {
          console.log(error);
          this.loading.page = false
        }
      },
  
      async deleteKlaim(params){
        console.log(params);
        this.loading.table = true
        try {
          const payload = {
            id_detail: params.temp_id
          }
          const response = await this.asyncAxiosDelete('klaim_kesehatan/klaim_detail', 'json', this.getAuth, payload);
          this.fetchReviseData()
          this.loading.table = false
        } catch (error) {
          console.log(error);
          this.loading.table = false
        }
      },
      
      addDetailRevise(){
        this.loading.table = true
        this.loading.add = true
        this.form.validateFields( async (err, values) => {
          if(err){
            this.displayMessage("form-warning");
            this.loading.table = false
            this.loading.add = false
            return;
          }
  
          try {
            const payload = new FormData()
            payload.append("tgl_invoice", moment(values.invoice_date).format('YYYY-MM-DD'))
            payload.append("description", values.description)
            payload.append("nilai_klaim", values.nilai_klaim)
            payload.append("temp_id", Date.now())
            payload.append("id_hdr", this.id)
            if(values.dokumen){
              payload.append('file', values.dokumen.file);
            }
  
            const response = await this.asyncAxiosPost("klaim_kesehatan/detail_klaim", "formdata", this.getAuth, payload)
            this.displayMessageValue("success-basic", "Detail klaim berhasil ditambahkan");
            this.fetchReviseData();
            this.form.resetFields([
              'description',
              'dokumen',
              'invoice_date',
              'nilai_klaim',
              'note'
            ])
            this.fileList = []
            this.loading.table = false
            this.loading.add = false
          } catch (error) {
            console.log(error);
            
            this.displayMessageValue("error-basic", error);
            this.loading.table = false
            this.loading.add = false
          }
  
        });
      },
  
      async saveEditRevise(){
        this.loading.table = true
        this.loading.update = true
        this.form.validateFields( async (err, values) => {
          if(err){
            this.displayMessage("form-warning");
            this.loading.table = false
            this.loading.update = false
            return;
          }
  
          try {
            const payload = new FormData()
            payload.append('id_detail', this.state_data.id)
            payload.append('tgl_invoice', moment(values.invoice_date).format('YYYY-MM-DD'))
            payload.append("description", values.description)
            payload.append("nilai_klaim", values.nilai_klaim)
            payload.append("temp_id", Date.now())
            payload.append("id_hdr", this.id)
            if(values.dokumen){
              payload.append('file', values.dokumen.file);
            }
            const response = await this.asyncAxiosPost('klaim_kesehatan/update_detail_klaim', 'formdata', this.getAuth, payload)
            this.displayMessageValue("success-basic", "Detail klaim berhasil diubah");
            this.fetchReviseData();
            this.form.resetFields([
              'description',
              'dokumen',
              'invoice_date',
              'nilai_klaim',
              'note'
            ])
            this.fileList = []
            this.loading.table = false
            this.loading.update = false
          } catch (error) {
            console.log(error);
            
            this.displayMessageValue("error-basic", error);
            this.loading.table = false
            this.loading.update = false
          }
        });
      },
  
      async submitRevise(){
        this.loading.submit = true
        if(this.listData.length == 0){
          this.displayMessageValue("error-basic", 'Silahkan isi detail informasi terlebih dahulu');
          this.loading.submit = false
          return 
        }else {
          try {
            const payload = {
              id_hdr: this.id
            }
            const response = await this.asyncAxiosPost("klaim_kesehatan/revise", "json", this.getAuth, payload)
            this.loading.submit = false
            this.displayMessageValue("success-basic", "Klaim kesehatan berhasil direvisi");
            this.back()
          } catch (error) {
            this.displayMessageValue("error-basic", error);
            this.loading.submit = false
          }
        }
      },

      onSearch(value){
        const search = value.toLowerCase()
        this.filteredComboName = this.comboName.filter(c =>
          c.tlc.toLowerCase().includes(search) ||
          c.name.toLowerCase().includes(search)
        )
      }
  
    }
  }
  </script>
  
  <style>
  .btn-cta {
    /* display: flex;
    justify-content: flex-end; */
    margin-top: 14px;
  }
  
  .mt-14 {
    margin-top: 14px !important;
  }
  
  .ant-divider-horizontal {
    margin: 10px 0 !important;
  }
  </style>